import { Redirect } from "react-router-dom";
import Util from "../../Util";
import { useEffect, useState, useMemo, useCallback } from "react";
import style from "./Style.module.css";
import SelectSearch from "react-select-search";

import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";

const PERMISSION_SHEET = 1;
const PERMISSION_FINANCE = 2;
const PERMISSION_HR = 3;
const PERMISSION_NAME_MAP = {
  1: "สิทธิ์จัดการชีท",
  2: "สิทธิ์จัดการการเงิน/ยอดขาย",
  3: "สิทธิ์จัดการ Staff",
};

const StaffPermission = (props) => {
  const [columnFilters, setColumnFilters] = useState([]);
  const [redirect, setRedirect] = useState(false);
  const [allperms, setAllPerms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [possibleStores, setPossibleStores] = useState([]);
  const [selectedUniNew, setSelectedUniNew] = useState("-2");
  const [facebookIDNew, setfacebookIDNew] = useState("");

  const columns = useMemo(() => {
    const addPerm = async (row, perm) => {
      let conf = window.confirm(
        `คุณต้องการเพิ่ม ${PERMISSION_NAME_MAP[perm]} สำหรับ ${row.userName} ใช่หรือไม่?`
      );
      if (conf) {
        setLoading(true);
        await Util.sendPost("/api/moresheetStaff/addPermission", {
          facebookID: row.facebookID,
          store: row.storeCode,
          perm: perm,
        });
        setLoading(false);
        await fetchPerms();
      }
    };

    const removePerm = async (row, perm) => {
      let conf = window.confirm(
        `คุณต้องการลบ ${PERMISSION_NAME_MAP[perm]} สำหรับ ${row.userName} ใช่หรือไม่?`
      );
      if (conf) {
        setLoading(true);
        await Util.sendPost("/api/moresheetStaff/removePermission", {
          facebookID: row.facebookID,
          store: row.storeCode,
          perm: perm,
        });
        setLoading(false);
        await fetchPerms();
      }
    };

    return [
      {
        accessorKey: "facebookID",
        cell: (info) => info.getValue(),
        header: "รหัสผู้ซื้อ",
      },
      {
        accessorKey: "userName",
        cell: (info) => info.getValue() || "??",
        header: "ชื่อ",
      },
      {
        accessorKey: "storeName",
        cell: (info) => info.getValue() || "??",
        header: "มหาวิทยาลัย",
      },
      {
        accessorKey: "hasSheet",
        cell: (info) =>
          info.getValue().toString() === "true" ? (
            <div
              className={style.hasPerm}
              onClick={() => removePerm(info.row.original, PERMISSION_SHEET)}
            >
              มี
            </div>
          ) : (
            <div
              className={style.noPerm}
              onClick={() => addPerm(info.row.original, PERMISSION_SHEET)}
            >
              ไม่มี
            </div>
          ),
        header: "สิทธิ์จัดการชีท",
        meta: {
          filterVariant: "select",
        },
        filterFn: "boolean",
      },
      {
        accessorKey: "hasFinance",
        cell: (info) =>
          info.getValue().toString() === "true" ? (
            <div
              className={style.hasPerm}
              onClick={() => removePerm(info.row.original, PERMISSION_FINANCE)}
            >
              มี
            </div>
          ) : (
            <div
              className={style.noPerm}
              onClick={() => addPerm(info.row.original, PERMISSION_FINANCE)}
            >
              ไม่มี
            </div>
          ),
        header: "สิทธิ์จัดการการเงิน/ยอดขาย",
        meta: {
          filterVariant: "select",
        },
        filterFn: "boolean",
      },
      {
        accessorKey: "hasHr",
        cell: (info) =>
          info.getValue().toString() === "true" ? (
            <div
              className={style.hasPerm}
              onClick={() => removePerm(info.row.original, PERMISSION_HR)}
            >
              มี
            </div>
          ) : (
            <div
              className={style.noPerm}
              onClick={() => addPerm(info.row.original, PERMISSION_HR)}
            >
              ไม่มี
            </div>
          ),
        header: "สิทธิ์จัดการ Staff",
        meta: {
          filterVariant: "select",
        },
        filterFn: "boolean",
      },
    ];
  }, []);

  const fetchPerms = async () => {
    setLoading(true);
    const data = await Util.sendGet("/api/moresheetStaff/listPermissions", {});
    setLoading(false);
    if (!data.success) setRedirect(true);
    const allperms = data.data.allperms;
    const permTable = {};
    for (const perm of allperms) {
      const key = `${perm.facebookID},${perm.store}`;
      if (!permTable.hasOwnProperty(key)) {
        permTable[key] = {
          hasSheet: false,
          hasFinance: false,
          hasHr: false,
          storeCode: perm.store,
          storeName: perm.store === -1 ? "GLOBAL ADMIN" : perm.storeName?.[0],
          userName: perm.userName,
        };
      }
      if (perm.type === PERMISSION_SHEET) {
        permTable[key].hasSheet = true;
      } else if (perm.type === PERMISSION_FINANCE) {
        permTable[key].hasFinance = true;
      } else if (perm.type === PERMISSION_HR) {
        permTable[key].hasHr = true;
      }
    }
    const permTableArray = Object.entries(permTable).map((ent) => {
      return { ...ent[1], facebookID: ent[0].split(",")[0] };
    });
    setAllPerms(permTableArray);
    setPossibleStores(data.data.stores);
  };

  const booleanFilterFn = (row, columnId, filterValue) => {
    const cellValue = row.getValue(columnId);
    return cellValue.toString() === filterValue.toString();
  };

  const table = useReactTable({
    data: allperms,
    columns,
    filterFns: {
      boolean: booleanFilterFn,
    },
    state: {
      columnFilters,
    },
    onColumnFiltersChange: setColumnFilters,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(), //client side filtering
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
    debugHeaders: true,
    debugColumns: false,
  });

  useEffect(() => {
    fetchPerms();
  }, []);

  const genUniOptions = () => {
    if (possibleStores.length === 0) return [{ value: "0", name: "" }];
    return possibleStores.map(({ name, code }) => ({
      value: code.toString(),
      name: name[0],
    }));
  };

  const addNewPerm = async (facebookID, store) => {
    const perm = 1;
    let conf = window.confirm(
      `คุณต้องการเพิ่ม ${PERMISSION_NAME_MAP[perm]} สำหรับ ${facebookID} ใช่หรือไม่?`
    );
    if (conf) {
      setLoading(true);
      await Util.sendPost("/api/moresheetStaff/addPermission", {
        facebookID: facebookID,
        store: store,
        perm: perm,
      });
      setLoading(false);
      await fetchPerms();
    }
  };

  return (
    <div className={style.pageContainer}>
      {redirect && <Redirect to="/staff/" />}
      {loading && <div className={style.loader}>Loading...</div>}
      <p>
        <b>วิธีใช้</b>
      </p>
      <p>
        1. สามารถเลื่อนดูสิทธิ์ต่างๆของแต่ละคนในแต่ละมหาวิทยาลัยได้
        โดยทุกคนจะเห็นแค่ข้อมูลของ ม.ที่ตัวเองมีสิทธิ์จัดการ staff
        <br />
        2. กดที่ปุ่มแดงและเขียวจะเป็นการให้/ลบสิทธิ์นั้นๆ โดยจะมีข้อความ confirm
        ก่อนแก้ไขจริง หากลบสิทธิ์ครบทั้ง 3 ช่องข้อมูลจะหายไป
        <br />
        3. สามารถใช้ฟอร์มข้างล่างนี้เพื่อเพิ่มสิทธิ์กับคน/ม. ที่ไม่มีในตาราง
        โดยจะได้รับสิทธิ์จัดการชีทโดยเริ่มต้น "รหัสผู้ซื้อ" สามารถหาได้จากหน้า
        "ชีทของฉัน"
      </p>

      <div className={style.newPermForm}>
        <b>เพิ่มสิทธิ์ใหม่</b>
        <div className={style.formInline}>
          <span>รหัสผู้ซื้อ: </span>
          <input
            value={facebookIDNew}
            onChange={(event) => {
              setfacebookIDNew(event.currentTarget.value);
            }}
            className={style.facebookID}
            type="text"
          />
          <span>มหาวิทยาลัย: </span>
          <div className={style.ssContainer}>
            <SelectSearch
              options={genUniOptions()}
              value={selectedUniNew}
              onChange={(value) => {
                setSelectedUniNew(value.value);
              }}
            />
          </div>
          <div
            className={style.sendButton}
            onClick={() => {
              addNewPerm(facebookIDNew.trim(), parseInt(selectedUniNew));
            }}
          >
            เพิ่มสิทธ์
          </div>
        </div>
      </div>

      <table className={style.table}>
        <thead className={style.thead}>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                return (
                  <th
                    className={style.thd}
                    key={header.id}
                    colSpan={header.colSpan}
                  >
                    {header.isPlaceholder ? null : (
                      <>
                        <div
                          {...{
                            onClick: header.column.getToggleSortingHandler(),
                          }}
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                          {{
                            asc: " 🔼",
                            desc: " 🔽",
                          }[header.column.getIsSorted()] ?? null}
                        </div>
                        {header.column.getCanFilter() ? (
                          <div>
                            <Filter column={header.column} />
                          </div>
                        ) : null}
                      </>
                    )}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => {
            return (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => {
                  return (
                    <td className={style.tdBody} key={cell.id}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

const Filter = ({ column }) => {
  const columnFilterValue = column.getFilterValue();
  const { filterVariant } = column.columnDef.meta ?? {};

  const selectCallback = useCallback(
    (e) => column.setFilterValue(e.target.value),
    [column]
  );
  const textCallback = useCallback(
    (value) => column.setFilterValue(value),
    [column]
  );

  return filterVariant === "select" ? (
    <select onChange={selectCallback} value={columnFilterValue?.toString()}>
      <option value="">All</option>
      <option value="true">true</option>
      <option value="false">false</option>
    </select>
  ) : (
    <DebouncedInput
      onChange={textCallback}
      placeholder={`Search...`}
      type="text"
      value={columnFilterValue ?? ""}
    />
  );
};

// A typical debounced input react component
function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 200,
  ...props
}) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value);
    }, debounce);

    return () => clearTimeout(timeout);
  }, [value, debounce, onChange]);

  return (
    <input
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default StaffPermission;
